import React from 'react';
import { useSlideIndex } from '../common/landingHooks';

const ChevronL = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>;
const ChevronR = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6" /></svg>;
const LinkedInIcon = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" /><rect x="2" y="9" width="4" height="12" /><circle cx="4" cy="4" r="2" /></svg>;

const ADVISORS = [
    {
        tag: 'Advisory Board', name: 'Paul Morris', role: 'Head of Growth Advisory', linkedin: 'https://www.linkedin.com/in/paul-morrisba884730',
        img: require('../../../../images/landing-pages/about-us/paul-morris.png'),
        bullets: [
            "Until July 2026 led BDOs Growth Advisory practice nationally",
            'Former Partner, Livingbridge VC — 14+ years in tech-enabled businesses',
            'Director, Barclays Bank — 18 years across credit and leveraged finance',
        ],
    },
    {
        tag: 'Advisory Board', name: 'Alex Faulconbridge', role: 'Investment Manager (FoF)', linkedin: 'https://www.linkedin.com/in/alexfaulconbridge',
        img: require('../../../../images/landing-pages/about-us/alex-faulconbridge.jpg'),
        bullets: [
            'Involved in British Business Bank’s deployment of its funds into sector-specific venture and growth funds',
            'Supported £200m+ across 10 funds spanning climate tech and fintech',
            'CFA Investment Foundations qualified; Bloomberg Market Concepts certified',
        ],
    },
    {
        tag: 'Advisory Board', name: 'Jim Tunstall', role: 'CEO & Scale-Up Expert', linkedin: 'https://www.linkedin.com/in/jamestunstall-3b7336341',
        img: require('../../../../images/landing-pages/about-us/jim-tunstall.jpeg'),
        bullets: [
            'Devised Innovate UK Scaleup Programme — 300+ SMEs, £789m+ capital raised',
            'Founded BPS Group — zero to £14m, 4 companies, 87 staff, successful trade sale',
            '35+ years as CEO, MD, and transformation leader across SMEs and large organisations',
        ],
    },
];

const renderAdvisorSlide = (a, key, isClone = false) => (
    <div className="lp-about-slide" key={key} aria-hidden={isClone || undefined}>
        <div className="lp-about-advisor-card">
            <img className="photo" src={a.img} alt={a.name} />
            <div className="copy">
                <div className="tag">{a.tag}</div>
                <div className="name">{a.name}</div>
                <div className="role">{a.role}</div>
                <a className="li" href={a.linkedin} target="_blank" rel="noopener noreferrer"><LinkedInIcon />LinkedIn</a>
                <div className="bullets">
                    {a.bullets.map((b, j) => <div key={j}><span>→</span><span>{b}</span></div>)}
                </div>
            </div>
        </div>
    </div>
);

const AboutAdvisorySlider = () => {
    const { index, trackStyle, next, prev, goTo, pause, resume } = useSlideIndex(ADVISORS.length, { autoplayMs: 5000 });

    return (
        <section className="lp-about-advisory">
            <div className="lp-container">
                <div className="lp-badge" data-lp-reveal><span />Advisory board &amp; investors</div>
                <div className="lp-sec-head" style={{ margin: '0 0 48px' }}>
                    <div>
                        <h2 className="lp-h2" data-lp-reveal>Senior expertise, backing the mission.</h2>
                        <p className="lp-sub" data-lp-reveal data-lp-delay="60">People who understand both the problem and the opportunity.</p>
                    </div>
                    <div className="lp-arrows">
                        <button className="lp-arrow" aria-label="Previous advisor" onClick={prev}><ChevronL /></button>
                        <button className="lp-arrow" aria-label="Next advisor" onClick={next}><ChevronR /></button>
                    </div>
                </div>
            </div>

            <div className="lp-about-slide-viewport" onMouseEnter={pause} onMouseLeave={resume}>
                <div className="lp-about-slide-track" style={trackStyle}>
                    {ADVISORS.map((a, i) => renderAdvisorSlide(a, i))}

                    {/* <div className="lp-about-slide">
                        <div className="lp-about-backers-card">
                            <div className="tag">Investors including</div>
                            <div className="rows">
                                <div className="row">
                                    <img src={require('../../../../images/landing-pages/about-us/saul.jpg')} alt="Saul Nathan" />
                                    <div>
                                        <div className="name">Saul Nathan</div>
                                        <div className="role">Ex Chairman, Global Capital Markets</div>
                                        <div className="org">Morgan Stanley</div>
                                    </div>
                                </div>
                                <div className="divider" />
                                <div className="row">
                                    <img src={require('../../../../images/landing-pages/about-us/fiona-vickers.png')} alt="Fiona Vickers" />
                                    <div>
                                        <div className="name">Fiona Vickers</div>
                                        <div className="role">Managing Director, Digital EMEA</div>
                                        <div className="org">Korn Ferry International</div>
                                    </div>
                                </div>
                                <div className="divider" />
                                <div className="backers-row">
                                    <img className="backers-strip" src={require('../../../../images/landing-pages/about-us/other-investor.png')} alt="Other investors" />
                                    <p className="fine">Fractional CFOs experienced in fund-raising, exits &amp; M&amp;A, who invested after using the platform.</p>
                                </div>
                            </div>
                        </div>
                    </div> */}

                    {/* Clone of the first slide — the forward wrap animates onto it, then snaps back */}
                    {renderAdvisorSlide(ADVISORS[0], 'clone-first', true)}
                </div>
            </div>

            <div className="lp-container lp-about-slide-foot">
                <span>{index + 1} / {ADVISORS.length}</span>
                <div className="lp-dots">
                    {Array.from({ length: ADVISORS.length }).map((_, i) => (
                        <button key={i} className={`lp-dot ${i === index ? 'is-active' : ''}`} aria-label={`Go to slide ${i + 1}`} onClick={() => goTo(i)} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default AboutAdvisorySlider;
